export const CREATE_CATEGORY_MODAL_WIDTH = 580;
export const MODAL_WIDTH = 540;
export const MOVE_ARTICLE_MODAL_WIDTH = 580;
export const PUBLISHING_OVERLAY_WIDTH = 150;
export const PUBLISHED_IMAGE_OFFSET_BOTTOM = 23;
export const PUBLISHED_IMAGE_OFFSET_TOP = 99;
export const PUBLISHED_IMAGE_WIDTH = 118;